export const siteConfig = {
  name: '久久网',
  tagline: '官方入口·海量资源一站直达',
  description: '久久网是您信赖的综合性网络平台，汇聚海量优质内容资源，为用户提供便捷高效的一站式服务体验。无论您寻找娱乐、资讯还是实用工具，久久网都能满足您的多元需求，立即访问久久网，开启全新网络体验。',
  keywords: '久久网,久久网官网,久久网入口,久久网资源,久久网平台,久久网最新地址,久久网在线服务',
  url: 'https://www.99net.com',
  canonicalUrl: 'https://www.99net.com',
  foundedYear: '2018',
  email: 'contact@99net.com',
  phone: '400-888-9999',
  address: '北京市朝阳区建国路88号久久大厦A座',
  wechat: 'jiujiu_net',
  weibo: '@久久网官方',
  stats: {
    totalArticles: 1248,
    totalUsers: '500万+',
    dailyVisitors: '80万+',
    categories: 8,
  },
};